<label *ngIf="label">{{label}}</label>
<mat-form-field class="w-full">
  <input
    *ngIf="formControlName"
    matInput
    [placeholder]="placeholder"
    [formControlName]="formControlName"
    (input)="onChange.emit($event)"
  />
  <input
    matInput
    *ngIf="!formControlName"
    [placeholder]="placeholder"
    (input)="onChange.emit($event)"
    [type]="htmlType"
    [value]="value"/>
</mat-form-field>
